import { Avatar, Typography, Alert } from "@mui/material";
import IdentifierInput from "./IdentifierInput";
import OtpInputForm from "./OtpInputForm";
import { useOtp } from "context/OtpContext";
import BasicLayout from "../components/BasicLayout";
import bgImage from "assets/images/icons/catering-icons/auth-banner.jpg";
import SideBanner from "../../../examples/LayoutContainers/SideBanner";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import SimpleBackdrop from "components/MDLoader_Backdrop";
import { OTP_LENGTH } from "../../../constants/authConstants";
import MailOutlineIcon from "@mui/icons-material/MailOutline"; // MUI icon
import { useEffect, useState } from "react";
import PasswordSignIn from "./PasswordSignIn";
import KnowMeForm from "./KnowMeForm";
import { useAuth } from "context";
import { Link, useNavigate } from "react-router-dom";
import { setGtmCode } from "../../../core/AuthHelper";
import PhoneIcon from "@mui/icons-material/Phone";
import config from "config/config";
import { GoogleOAuthProvider } from "@react-oauth/google";

const isPhoneNumber = (value) => {
  const digitsOnly = value.replace(/\D/g, "");
  return /^(\+?[0-9]{10,15})$/.test(digitsOnly);
};

const googleClientId = config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].GOOGLE_CLIENT_ID;
const OTPSignIn = () => {
  const landingAccessToken =
    new URL(window.location.href).searchParams.get("landing_page_tokens") || null;

  const { isOtpSent, isLoading, message, identifier } = useOtp();
  const { showSnackbarWithMessage, saveAuthData } = useAuth();
  const navigate = useNavigate();

  const [level, setLevel] = useState(0);

  const [authSection, setAuthSection] = useState("code");

  useEffect(() => {
    if (landingAccessToken) {
      saveAuthData(JSON.parse(landingAccessToken));
      const gtmCode = new URL(window.location.href).searchParams.get("s") || null;
      if (gtmCode) {
        setGtmCode(gtmCode);
      }
      navigate("/dashboard");
      showSnackbarWithMessage({
        type: "success",
        message: "Welcome to Catering Rewards! Head to Profile Page for further settings!",
      });
    }
  }, [landingAccessToken]);

  return (
    <MDBox
      display={{
        xs: "flex",
        xl: "row",
        background: "linear-gradient(to right, rgba(1,233,98,0.1), rgba(0,123,255,0.1))",
      }}
      flexDirection={{
        xs: "column-reverse",
        xl: "row",
      }}
    >
      <SideBanner />
      <GoogleOAuthProvider clientId={{ googleClientId }}>
        <BasicLayout image={bgImage}>
          {authSection === "code" && (
            <>
              {level === 0 ? (
                <>
                  {/* Message alert  */}
                  <Card sx={{ margin: 2, marginLeft: 3, maxWidth: "448px" }}>
                    {message && message.message && (
                      <>
                        {/* Show error messages */}
                        {message?.type === "error" && (
                          <Alert
                            severity="error"
                            sx={{
                              borderRadius: "8px",
                              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                              "& .MuiAlert-icon": {
                                fontSize: "1.2rem",
                              },
                              "& .MuiAlert-message": {
                                fontSize: "0.875rem",
                                fontWeight: 500,
                              },
                            }}
                          >
                            {message?.message}
                          </Alert>
                        )}

                        {/* Show success messages only if they include "login to continue" */}
                        {message?.type === "success" && message.message && (
                          <Alert
                            severity="success"
                            sx={{
                              borderRadius: "8px",
                              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                              "& .MuiAlert-icon": {
                                fontSize: "1.2rem",
                              },
                              "& .MuiAlert-message": {
                                fontSize: "0.875rem",
                                fontWeight: 500,
                              },
                            }}
                          >
                            {message?.message}
                          </Alert>
                        )}
                      </>
                    )}
                  </Card>

                  <Card sx={{ margin: 2, marginLeft: 3, maxWidth: "548px" }}>
                    <MDBox mx={2} p={2} textAlign="center" minWidth={{ xs: "320px", xl: "380px" }}>
                      {/*Show Email/Phone Icon On OTP Sent */}
                      {isOtpSent && (
                        <MDBox
                          mb={"24px"}
                          mt={"12px"}
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Avatar
                            sx={{
                              bgcolor: "#CEFFE1",
                              width: 48,
                              height: 48,
                            }}
                          >
                            {isPhoneNumber(identifier) ? (
                              <PhoneIcon sx={{ fontSize: 24, color: "rgb(16, 121, 72)" }} />
                            ) : (
                              <MailOutlineIcon sx={{ fontSize: 24, color: "rgb(16, 121, 72)" }} />
                            )}
                          </Avatar>
                        </MDBox>
                      )}

                      <MDTypography
                        sx={{ color: "#101828", fontSize: "28px" }}
                        variant="h4"
                        fontWeight="medium"
                        mt={1}
                        mb={"20px"}
                      >
                        {!isOtpSent
                          ? "Log in or sign up"
                          : `Please check your ${isPhoneNumber(identifier) ? "SMS" : "email"} `}
                      </MDTypography>
                    </MDBox>

                    <MDBox pb={"24px"} px={"24px"}>
                      {!isOtpSent ? (
                        <IdentifierInput setAuthSection={setAuthSection} />
                      ) : (
                        <OtpInputForm setLevel={setLevel} length={OTP_LENGTH} />
                      )}
                    </MDBox>
                  </Card>
                </>
              ) : (
                <Card sx={{ margin: 2, marginLeft: 3, maxWidth: "408px" }}>
                  <MDBox mx={2} p={2} textAlign="center" minWidth={{ xs: "320px", xl: "380px" }}>
                    <MDTypography
                      sx={{ color: "#101828", fontSize: "28px" }}
                      variant="h4"
                      fontWeight="medium"
                      mt={1}
                      mb={"20px"}
                    >
                      Let us get to know you
                    </MDTypography>
                  </MDBox>

                  <MDBox pb={"24px"} px={"24px"}>
                    <KnowMeForm setLevel={setLevel} />
                  </MDBox>

                  <Typography
                    mx={2}
                    px={2}
                    pb={2}
                    variant="body2"
                    textAlign={"center"}
                    style={{
                      maxWidth: "360px",
                      fontSize: "0.8rem",
                      color: message && message.type === "error" ? "#f44336" : "#238856",
                      fontWeight: 500,
                    }}
                  >
                    {message?.type === "error" && message?.message}
                  </Typography>
                </Card>
              )}
              {isLoading && <SimpleBackdrop />}
            </>
          )}

          {/* PASSWORD SIGN IN FOR EXISTING USERS  */}
          {authSection === "password" && <PasswordSignIn setAuthSection={setAuthSection} />}
        </BasicLayout>
      </GoogleOAuthProvider>
    </MDBox>
  );
};

export default OTPSignIn;
